export class EstimateCoverageBase {
  coverage_type: string;
  carrier_name: string | null;
  coverage_amount: string;
  coverage_percentage: string;
  source: string | null;
  coverage_calculated_at: string | null;
}

export class PatientEstimateItemBase {
  price: string;
  estimate_id: number;
  appointment_index: number;
  description: string;
  id: number;
  position: number;
  tooth_location: string | null;
  canada_supplementary_items_for_estimate: Array<CanadaSupplementaryItemBase>;
  insurance_rebate_value: string | null;
  coverages: Array<EstimateCoverageBase>;
}

export class PatientEstimateBase {
  template_name: string;
  patient_id: number;
  practitioner_id: number;
  created_at: string;
  description: string;
  signed: boolean;
  estimate_items: Array<PatientEstimateItemBase>;
  footnote: string;
  payment_terms: string;
  id: number;
  nhs_value: string;
  treatment_plan_id: number | null;
  html: string | null;
  treatment_plan_completed: boolean;
  hide_estimate_items: boolean;
}

export class CanadaSupplementaryItemBase {
  id: string;
  name: string;
  price: string;
  code: string;
  insurance_rebate_value: string | null;
  primary_coverage_amount: string | null;
  secondary_coverage_amount: string | null;
}
